<template>
  <div class="electrinic-journals-list">
    <a-tabs type="card" @change="changeTag">
      <a-tab-pane key="1" tab="电子期刊">
      </a-tab-pane>
      <a-tab-pane key="2" tab="下期预告">
      </a-tab-pane>
    </a-tabs>
    <div class="hint">投稿作品不限体载、文章、摄影、手工作品均可，投稿邮箱：2355301541@qq.com</div>
    <div class="search-form">
      <a-form layout="inline" :form="searchForm">
        <a-form-item label="标题" ISSUE="搜索" v-if="activityTab == 1">
          <a-input v-model="seek.keywords" allowClear placeholder="请输入标题" />
        </a-form-item>
        <a-form-item label="发布状态" v-if="activityTab == 1">
          <a-select style="width: 120px" v-model="seek.issue" placeholder="全部">
            <a-select-option v-for="item in label" :key="item.key" :value="item.key">{{
              item.value
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态选择" v-if="activityTab == 2">
          <a-select style="width: 120px" v-model="nextSeek.status" placeholder="全部">
            <a-select-option v-for="item in label" :key="item.key" :value="item.key">{{
              item.value
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="发布时间" v-if="activityTab == 1">
          <a-range-picker v-model="defultDate" @change="(val, format)=>onDateChange(format,seek,'issue_time_start','issue_time_end')" style="width:280px" />
        </a-form-item>
        <!-- <a-form-item label="创建时间" v-if="activityTab == 2">
          <a-range-picker v-model="creatDate" @change="(val, format)=>onDateChange(format,nextSeek,'created_at_start','created_at_end')" style="width:280px" />
        </a-form-item>
        <a-form-item v-if="activityTab == 2" label="编辑时间">
          <a-range-picker v-model="updatedDate" @change="(val, format)=>onDateChange(format,nextSeek,'updated_at_start','updated_at_end')" style="width:280px" />
        </a-form-item> -->
        <a-form-item v-if="activityTab == 2" label="预告时间">
          <a-range-picker v-model="activityDate" @change="(val, format)=>onDateChange(format,nextSeek,'activity_start','activity_end')" style="width:280px" />
        </a-form-item>
        <a-form-item>
          <a-button @click="submit" icon="search" type="primary">查询</a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset" icon="delete" type="primary" ghost>清空</a-button>
        </a-form-item>
      </a-form>
    </div>
    <next-list :activityTab="activityTab" @changePage="(v) => {this.pagination = v;}" :nextList="nextList" @updateList="updateList" :pagination="nextPagination" v-show="activityTab == 2" />
    <publist-list :activityTab="activityTab" @changePage="(v) => {this.pagination = v;}" :publishList="publishList" @updateList="updateList" :pagination="publistPagination" v-show="activityTab == 1" />
  </div>
</template>

<script>
import PublistList from '@/views/electrinicJournals/components/PublishList'
import NextList from '@/views/electrinicJournals/components/NextList'
import api from '@/api'
import { mapState, mapGetters } from 'vuex'
// const labels = store.state.label.data
export default {
  components: {
    PublistList,
    NextList
  },
  data() {
    return {
      // 搜索表单
      seek: {
        issue: -1,
        keywords: '',
        issue_time_start: '',
        issue_time_end: ''
      },
      condition: {},
      nextSeek: {
        status: 2,
        created_at_start: '',
        created_at_end: '',
        updated_at_start: '',
        updated_at_end: '',
        activity_start: '',
        activity_end: ''
      },
      list: {},
      searchForm: {},
      defultDate: [],
      creatDate: [],
      updatedDate: [],
      activityDate: [],
      activityTab: 1,
      label: [],
      publishList: [],
      nextList: [],
      // pagination: {
      //   page: 1,
      //   per_page: 10,
      //   total: 1000,
      // },
      nextPagination: {
        page: 1,
        per_page: 10,
        total: 1000
      },
      publistPagination: {
        page: 1,
        per_page: 10,
        total: 1000
      }
    }
  },
  methods: {
    changeTag(key) {
      this.chosedTab(parseInt(key))
    },
    // 提交
    submit() {
      this.activityTab === 1 ? (this.publistPagination.page = 1) : (this.nextPagination.page = 1)
      this.condition = this.activityTab === 1 ? this._.cloneDeep(this.seek) : this._.cloneDeep(this.nextSeek)
      this.getList()
    },
    // 重置
    reset() {
      if (this.activityTab === 1) {
        this.defultDate = []
        this.seek = {
          issue: -1,
          keywords: '',
          issue_time_start: '',
          issue_time_end: ''
        }
        this.condition = this._.cloneDeep(this.seek)
        this.publistPagination = {
          page: 1,
          per_page: 10,
          total: 1000
        }
      } else {
        this.activityDate = []
        this.nextSeek = {
          status: 2,
          created_at_start: '',
          created_at_end: '',
          updated_at_start: '',
          updated_at_end: '',
          activity_start: '',
          activity_end: ''
        }
        this.condition = this._.cloneDeep(this.nextSeek)
        this.nextPagination = {
          page: 1,
          per_page: 10,
          total: 1000
        }
      }
      this.getList()
    },
    // 状态
    chosedTab(val) {
      this.activityTab = val
      this.label = this.activityTab === 1 ? this.labels.PERIODICAL.ISSUE : this.labels.PERIODICAL_NOTICE.STATUS
      this.condition = this.activityTab === 1 ? this._.cloneDeep(this.seek) : this._.cloneDeep(this.nextSeek)
      this.getList()
    },
    async getList() {
      if (this.activityTab === 1) {
        const params = Object.assign({}, this.condition, {
          page: this.publistPagination.page,
          per_page: this.publistPagination.per_page
        })
        const { data } = await api.publishList(params)
        if (data) {
          const journalsList = JSON.parse(JSON.stringify(data))
          this.publishList = journalsList.periodicals
          this.publistPagination = journalsList.pagination
        }
      } else {
        const params = Object.assign({}, this.condition, {
          page: this.nextPagination.page,
          per_page: this.nextPagination.per_page
        })
        const { data } = await api.nextList(params)
        if (data) {
          const nextlist = JSON.parse(JSON.stringify(data))
          this.nextList = nextlist.periodicalNotices
          this.nextPagination = nextlist.pagination
        }
      }
    },
    updateList() {
      this.getList()
    },
    onDateChange(format, obj, start, end) {
      Object.assign(obj, {
        [start]: format[0],
        [end]: format[1]
      })
    },
    changeSeek(val) {
      this.seek.issue = val
    }
  },
  mounted() {
    // this.seek = {}
    // this.nextSeek = {}
    this.label = this.labels.PERIODICAL.ISSUE
    this.getList()
  },
  computed: {
    ...mapState({ labels: state => state.label.data })
  }
}
</script>

<style lang="less" scoped>
.electrinic-journals-list {
  .activity-tab {
    color: #fff;
    background: #333;
    border: none;
    height: 36px !important;
    line-height: 36px !important;
  }
  .list-title {
    & > span {
      width: 100px;
      display: inline-block;
      text-align: center;
      height: 34px;
      line-height: 34px;
      border: 1px solid #e8e7e7;
      cursor: pointer;
      font-size: 12px;
    }
  }
  .hint {
    margin: 10px 0 10px 0;
  }
  .search-form {
    margin-bottom: 10px;
  }
}
.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0;
}
.ant-table-small {
  border: none !important;
}
</style>
